import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AppSettings } from '../../config/config';
import { map } from 'rxjs/operators';
import { apiConstants } from '../constant/apiConstant';
import { commonFunctionService } from '../utils/commonFunctions';
@Injectable()
export class FeeManagementService {

  private URL = AppSettings.API_ENDPOINT;
  private URL_V3 = AppSettings.API_ENDPOINT_V3;
  private getPaymentGatewayList = apiConstants.getPaymentGatewayList;
  private paymentGatewayStatusUpdate = apiConstants.paymentGatewayStatusUpdate;
  private sendPaymentGatewayRequest = apiConstants.sendPaymentGatewayRequest;
  private studentCategoriesGetFeeStructureStudentListDiscount = apiConstants.studentCategoriesGetFeeStructureStudentListDiscount;
  private getSupportedCurrencyList = apiConstants.getSupportedCurrencyListAPI;
  private supportedCurrencyUpdate = apiConstants.supportedCurrencyUpdateAPI;
  
  headers: HttpHeaders;

  constructor(private http: HttpClient,private commonFunction : commonFunctionService) {
    const token = localStorage.getItem('usertoken');
    this.headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'authToken': token,
      'token': token
    })
  }

  gatewayList() {
    return this.http.get(this.URL_V3 + `${this.getPaymentGatewayList}/?feesType=schoolFees&lang=en`,
      { headers: this.headers }).pipe(map(res => res));
  }

  getSupportedCurrencyListAPI(body) {
    return this.http.get(this.URL_V3 + `${this.getSupportedCurrencyList}/?academicId=${body.academicId}&lang=${body.lang}`,
      { headers: this.headers }).pipe(map(res => res));
  }

  updateSupportedCurrencyAPI(body: any) {
    return this.http.post(`${this.URL_V3}${this.supportedCurrencyUpdate}`, body, { headers: this.headers }).pipe(
      map(res => res)
    );
  }

  updatePaymentGatewayStatus(body: any) {
    return this.http.post(`${this.URL_V3}${this.paymentGatewayStatusUpdate}`, body, { headers: this.headers }).pipe(
      map(res => res)
    );
  }

  gatewaySendRequest(body: any) {
    return this.http.post(`${this.URL_V3}${this.sendPaymentGatewayRequest}`, body, { headers: this.headers }).pipe(
      map(res => res)
    );
  }

  fetchFeeDashDetails(currentAcademic) {
    const params = { schoolId: localStorage.getItem('schoolinfo'), current_academic: currentAcademic };

    return this.http.post(this.URL + '/manageFees/totalfeesDetails',
      params, { headers: this.headers }).pipe(map(res => res));
  }

  getPaidLateFeeCount(currentAcademic) {
    const params = { academicId: currentAcademic }
    return this.http.post(this.URL + '/latefees/get/paid/late/fee/count',
      params, { headers: this.headers }).pipe(map(res => res));
  }

  getSchoolFee(dataFor, stdId, currentAcademic) {
    let json: any = { today: new Date().toISOString(), current_academic: currentAcademic };
    let url = '';
    if (dataFor === 'wholeclass') {
      url = '/manageFees/todayfeeByWholeClass';
      json = { today: new Date().toISOString(), current_academic: currentAcademic };
    } else if (dataFor === 'weekwholeclass') {
      url = '/manageFees/weeklyFeeDetailsByWholeClass';
      const t = new Date();
      t.setDate(t.getDate() - 7);
      json = {
        weekStartdate: t.toISOString(),
        weekEnddate: new Date().toISOString(), current_academic: currentAcademic
      };
    } else if (dataFor === 'weekforclass') {
      url = '/manageFees/weeklyFeeDetailsByClass';
      const t = new Date();
      t.setDate(t.getDate() - 7);
      json = {
        weekStartdate: t.toISOString(),
        weekEnddate: new Date().toISOString(), fkClassStandardsId: stdId, current_academic: currentAcademic
      };
    } else if (dataFor === 'monthwholeclass') {
      url = '/manageFees/monthlyFeesDetailsByWholeClass';
      const t = new Date();
      t.setDate(t.getDate() - 30);
      json = { monthStart: t.toISOString(), monthEnd: new Date().toISOString(), current_academic: currentAcademic };
    } else if (dataFor === 'monthforclass') {
      url = '/manageFees/monthlyFeeDetailByClass';
      const t = new Date();
      t.setDate(t.getDate() - 30);
      json = {
        monthStart: t.toISOString(),
        monthEnd: new Date().toISOString(),
        fkClassStandardsId: stdId,
        current_academic: currentAcademic
      };
    } else if (dataFor === 'summarywholeclass') {
      url = '/manageFees/wholeSummaryFeeDetailsByWholeClass';
      json = { current_academic: currentAcademic };
    } else if (dataFor === 'summaryforclass') {
      url = '/manageFees/wholeSummaryFeeDetailByClass';
      json = { fkClassStandardsId: stdId, current_academic: currentAcademic };
    }

    return this.http.post(this.URL + url, json, { headers: this.headers }).pipe(map(res => res));
  }

  todayFeeByClass(date, standardId, currentAcademic) {
    const params = { today: date, fkClassStandardsId: standardId, current_academic: currentAcademic };
    return this.http.post(this.URL + '/manageFees/todayFeeDetailsByClass',
      params, { headers: this.headers }).pipe(map(res => res));
  }

  getAvailableClass() {
    const params = {};
    return this.http.post(this.URL + '/classManagement/listStandards',
      params, { headers: this.headers }).pipe(map(res => res));
  }

  getClassSections(standardClassId) {
    const params = { standardClassId };
    return this.http.post(this.URL + '/classManagement/classmanagement_standard_SectionList',
      params, { headers: this.headers }).pipe(map(res => res));
  }

  getClassSectionsNotInFeesBoard(standardClassId, currentAcademic) {
    const params = { standardClassId, current_academic: currentAcademic };
    return this.http.post(this.URL + '/manageFees/feeboard/getclasssectionsnotinfeesboard',
      params, { headers: this.headers }).pipe(map(res => res));
  }

  getClassStandardsNotInFeesBoard(currentAcademic) {
    const params = { current_academic: currentAcademic };
    return this.http.post(this.URL + '/manageFees/feeboard/getclassstandardsnotinfeesboard',
      params, { headers: this.headers }).pipe(map(res => res));
  }


  feeComponentList(currentAcademic) {
    const params = { current_academic: currentAcademic };
    return this.http.post(this.URL + '/manageFees/feeComponentList',
      params, { headers: this.headers }).pipe(map(res => res));
  }

  getClassCategories(currentAcademic) {
    const params = { current_academic: currentAcademic };
    return this.http.post(this.URL + '/manageFees/feeboard/category',
      params, { headers: this.headers }).pipe(map(res => res));
  }

  getFeeBoardFees(classId, currentAcademic) {
    const params = { classId, current_academic: currentAcademic };
    return this.http.post(this.URL + '/feeBoard/feeboard',
      params, { headers: this.headers }).pipe(map(res => res));
  }

  getFeeBoardFees_v2(currentAcademic,currentPage) {
    const params = { current_academic: currentAcademic ,pageNumber : currentPage};

    return this.http.post(this.URL + '/manageFees/feeboard_v2',
      params, { headers: this.headers }).pipe(map(res => res));
  }

  addFeeTypeComponent(Name, includeInTerm, academicId, AppliesTo, duedate, currentAcademic) {
    const params = {
      Name,
      includeInTerm,
      academicId,
      AppliesTo,
      duedate,
      current_academic: currentAcademic
    };
    return this.http.post(this.URL + '/manageFees/createNewfeeComponent',
      params, { headers: this.headers }).pipe(map(res => res));
  }

  updateFeeTypeComponent(Name, duedate, feesTypeId, currentAcademic) {
    const params = {
      name: Name,
      dueDate: duedate,
      feesTypeId,
      current_academic: currentAcademic
    };
    return this.http.post(this.URL + '/manageFees/updateFeeTypeComponent_v2',
      params, { headers: this.headers }).pipe(map(res => res));
  }

  fetchAcademicList() {
    const params = {};
    return this.http.post(this.URL + '/academiclist',
      params, { headers: this.headers }).pipe(map(res => res));
  }

  fetchSchoolFeeTerms(currentAcademic) {
    const params = { current_academic: currentAcademic };
    return this.http.post(this.URL + '/manageFees/feesTermNameList',
      params, { headers: this.headers }).pipe(map(res => res));
  }

  fetchDeletedLateFeeList(currentAcademic) {
    const params = { academicId: currentAcademic };
    return this.http.post(this.URL + '/latefees/get/deleted/list',
      params, { headers: this.headers }).pipe(map(res => res));
  }

  fetchWaivedOffLateFeeList(currentAcademic) {
    const params = { academicId: currentAcademic };
    return this.http.post(this.URL + '/latefees/get/waive/off/info',
      params, { headers: this.headers }).pipe(map(res => res));
  }

  fetchPaidLateFeeList(params) {
    return this.http.post(this.URL + '/latefees/get/paid/late/fee/info',
      params, { headers: this.headers }).pipe(map(res => res));
  }

  fetchLateFeeConfig(currentAcademic) {
    const params = { academicId: currentAcademic };
    return this.http.post(this.URL + '/latefees/get',
      params, { headers: this.headers }).pipe(map(res => res));
  }


  newFetchLateFeeConfig(currentAcademic) {
    const params = { academicId: currentAcademic };
    return this.http.post(this.URL + '/get/late/fees',
      params, { headers: this.headers }).pipe(map(res => res));
  }

  deleteLateFee(pkLateFeesId) {
    const params = { lateFeesId: pkLateFeesId };
    return this.http.post(this.URL + '/latefees/delete',
      params, { headers: this.headers }).pipe(map(res => res));
  }

  createLateFees(lateFee) {
    return this.http.post(this.URL + '/latefees/add',
      lateFee, { headers: this.headers }).pipe(map(res => res));
  }

  createTerm(term, currentAcademic) {
    term.current_academic = currentAcademic;
    return this.http.post(this.URL + '/manageFees/addTermComponent',
      term, { headers: this.headers }).pipe(map(res => res));
  }

  addFeeBoard(fee, currentAcademic) {
    fee.current_academic = currentAcademic;
    return this.http.post(this.URL + '/manageFees/feeboard/addNewFees',
      fee, { headers: this.headers }).pipe(map(res => res));
  }

  getFeeBoardDetailsOfClassSection(classId, currentAcademic) {
    const params = { classId, current_academic: currentAcademic };
    return this.http.post(this.URL + '/manageFees/feeboard/categoryclassdetails',
      params, { headers: this.headers }).pipe(map(res => res));
  }

  updateFeesBoard(reqData, currentAcademic) {
    reqData.current_academic = currentAcademic;
    return this.http.post(this.URL + '/manageFees/feesFeeBoardCategoryUpdateClassFees',
      reqData, { headers: this.headers }).pipe(map(res => res));
  }

  insertAndUpdateFeeBoard(criteria, currentAcademic) {
    criteria.current_academic = currentAcademic;
    return this.http.post(this.URL + '/feeBoard/insertAndUpdateFeeBoard',
      criteria, { headers: this.headers }).pipe(map(res => res));
  }

  fetchFeeBoardHistorydetailView(structureId, classId, currentAcademic) {
    const params = { structureId, classId, current_academic: currentAcademic };
    return this.http.post(this.URL + '/feeBoard/getFeeBoardHistoryList',
      params, { headers: this.headers }).pipe(map(res => res));
  }

  fetchTermConfigHistorydetailView(structureId, feeTypeId, classId, currentAcademic) {
    const params = {
      structureId,
      feeTypeId,
      classId,
      current_academic: currentAcademic
    };

    return this.http.post(this.URL + '/manageFees/getTermConfigHistoryList',
      params, { headers: this.headers }).pipe(map(res => res));
  }

  getTermFeeConfig(classId, fkFeeStructuresId, currentAcademic) {
    const params = {
      classId,
      fkFeeStructuresId,
      current_academic: currentAcademic
    };
    return this.http.post(this.URL + '/manageFees/termfeeConfigurationListNew',
      params, { headers: this.headers }).pipe(map(res => res));
  }


  getTypeTermListWithPaidStatus(classId, feesTypeId, currentAcademic) {
    const params = { classId, feesTypeId, current_academic: currentAcademic };

    return this.http.post(this.URL + '/manageFees/updatableListTermFeeConfiguration',
      params, { headers: this.headers }).pipe(map(res => res));
  }

  updateTermConfigForStruc(obj, currentAcademic) {
    obj.current_academic = currentAcademic;
    return this.http.post(this.URL + '/manageFees/updateTermFeeConfigurationForStruc',
      obj, { headers: this.headers }).pipe(map(res => res));
  }

  searchStudent(search, byName, filterBy, currentAcademic, isStudentDeactivated) {
    const params = { search, byName, filterBy, current_academic: currentAcademic, isStudentDeactivated: isStudentDeactivated };
    return this.http.post(this.URL + '/feeCollection/searchStudent',
      params, { headers: this.headers }).pipe(map(res => res));
  }

  searchNewStudent(search, byName, filterBy, currentAcademic, isStudentDeactivated) {
    const params = { search, byName, filterBy, current_academic: currentAcademic, isStudentDeactivated: isStudentDeactivated };
    return this.http.post(this.URL + '/fee/collection/search/student',
      params, { headers: this.headers }).pipe(map(res => res));
  }

  getStudentFeeDashInfo(studentId, classId, currentAcademic) {
    const params = { studentId, classId, current_academic: currentAcademic };

    return this.http.post(this.URL + '/feeCollection/studentDetails',
      params, { headers: this.headers }).pipe(map(res => res));
  }

  studentAllAcademicFeeStatus(studentId) {
    const params = { studentId };

    return this.http.post(this.URL + '/feeCollection/studentAllAcademicFeeStatus',
      params, { headers: this.headers }).pipe(map(res => res));
  }

  studentSiblingsFee(studentId, mobileNumber, currentAcademic) {
    const params = { studentId, mobileNumber, current_academic: currentAcademic };

    return this.http.post(this.URL + '/feeCollection/studentSiblings',
      params, { headers: this.headers }).pipe(map(res => res));
  }

  getStudentFeeList(studentId, classId, currentAcademic) {
    const params = { studentId, classId, current_academic: currentAcademic };
    return this.http.post(this.URL + '/feeCollection/studentfeeslist',
      params, { headers: this.headers }).pipe(map(res => res));
  }

  
  getStudentFeeList_v2(studentId, classId, currentAcademic) {
    const params = { studentId, classId, current_academic: currentAcademic };
    return this.http.post(this.URL + '/fee/collection/student/fees/list',
      params, { headers: this.headers }).pipe(map(res => res));
  }

  waiveOffLateFee(params) {
    return this.http.put(this.URL + '/latefees/waive/off/amount',
      params, { headers: this.headers }).pipe(map(res => res));
  }

  sendPaymentInfo(payment, currentAcademic) {
    payment.current_academic = currentAcademic;
    const params = payment;
    return this.http.post(this.URL + '/feeCollection/insertFeeCollection_v2',
      params, { headers: this.headers }).pipe(map(res => res));
  }

  getFeeReceipt(paymentReceiptId, currentAcademic) {
    const params = { paymentReceiptId, current_academic: currentAcademic };
    return this.http.post(this.URL + '/feeCollection/getFeeReceipt_v3',
      params, { headers: this.headers }).pipe(map(res => res));
  }

  getFeeHistory(studentId, classId, feeHistoryPageNumber, currentAcademic) {
    const params = {
      studentId,
      classId,
      page: feeHistoryPageNumber,
      current_academic: currentAcademic
    };
    return this.http.post(this.URL + '/feeCollection/studentFeeHistory',
      params, { headers: this.headers }).pipe(map(res => res));
  }

  // Same endpoint the old component's DataTables server-side ajax hits directly
  // (feesmanage.component.ts initDataTableServerProcess) — exposed through the
  // service so the v2 page can page/search/sort it with plain HttpClient.
  getFeeCollectionDatatable(body) {
    return this.http.post(this.URL + '/feeCollection/feeCollection/byDate_v2/datatable',
      body, { headers: this.headers }).pipe(map(res => res));
  }

  getFeeHistoryForStudent(stdate, endate, currentAcademic, isLateFeeIncluded) {
    const params = { startDate: stdate, endDate: endate, current_academic: currentAcademic, isLateFee: isLateFeeIncluded };
    return this.http.post(this.URL + '/feeCollection/feeCollection/byDate_v3',
      params, { headers: this.headers }).pipe(map(res => res));
  }

  getFeeHistoryHeadsCollectedByAdmin(stdate, endate, adminId, currentAcademic, isLateFeeIncluded) {
    const params = {
      startDate: stdate,
      endDate: endate,
      adminId,
      current_academic: currentAcademic,
      isLateFee: isLateFeeIncluded
    };
    return this.http.post(this.URL + '/feeCollection/feeCollection/byDate/admincollected/groupdate',
      params, { headers: this.headers }).pipe(map(res => res));
  }

  getFeeHistoryHeadsCollectedFYByAdmin(stdate, endate, currentAcademic, isLateFee) {
    const params = {
      startDate: stdate,
      endDate: endate,
      current_academic: currentAcademic,
      isLateFee: isLateFee
    };
    return this.http.post(this.URL + '/feeCollection/feeCollection/byDate/admincollected_FY/groupdate',
      params, { headers: this.headers }).pipe(map(res => res));
  }

  getFeeHistoryHeadsCollectedFY(stdate, endate, isLateFee) {
    const params = {
      startDate: stdate,
      endDate: endate,
      isLateFee: isLateFee
    };
    return this.http.post(this.URL + '/feeCollection/feeCollection/byDate/admincollected_FY/groupdate/allacademics',
      params, { headers: this.headers }).pipe(map(res => res));
  }

  getFeeHistoryHeadsCollectedAllAcademics(stdate, endate, isLateFee) {
    const params = {
      startDate: stdate,
      endDate: endate,
      isLateFee: isLateFee
    };
    return this.http.post(this.URL + '/feeCollection/feeCollection/byDate/admincollected_FY/allacademics',
      params, { headers: this.headers }).pipe(map(res => res));
  }

  updateTerm(reqObj, currentAcademic) {
    reqObj.current_academic = currentAcademic;
    return this.http.post(this.URL + '/manageFees/updateTermComponent',
      reqObj, { headers: this.headers }).pipe(map(res => res));
  }

  /* discounts */
  fetchdiscount(AUTHTOKEN, currentAcademic) {
    const params = { current_academic: currentAcademic };
    const headers = new HttpHeaders();
    headers.append('Content-Type', 'application/json');
    headers.append('authToken', AUTHTOKEN);
    return this.http.post(this.URL + '/manageFees/discount/get',
      params, { headers: this.headers }).pipe(map(res => res));
  }

  addDiscount(components, discountAmountType, discountName, discountReason, discountAmount, feeStructuresId, AUTHTOKEN, currentAcademic) {
    const params = {
      discountAmount,
      discountTitle: discountName,
      discountReason,
      discountAmountType,
      componentList: components,
      feeStructuresId,
      current_academic: currentAcademic
    };
    const headers = new HttpHeaders();
    headers.append('Content-Type', 'application/json');
    headers.append('authToken', AUTHTOKEN);
    return this.http.post(this.URL + '/manageFees/discount/create',
      params, { headers: this.headers }).pipe(map(res => res));
  }

  applyDiscount(studentId, discountId, classId, AUTHTOKEN, currentAcademic) {
    const params = {
      studentIdList: studentId,
      schoolDiscountId: discountId,
      classId,
      current_academic: currentAcademic
    };
    const headers = new HttpHeaders();
    headers.append('Content-Type', 'application/json');
    headers.append('authToken', AUTHTOKEN);
    return this.http.post(this.URL + '/manageFees/applyDiscount',
      params, { headers: this.headers }).pipe(map(res => res));
  }

  applyDiscountv2(studentId, discountId, AUTHTOKEN, currentAcademic) {
    const params = {
      studentIdList: studentId,
      schoolDiscountId: discountId,
      current_academic: currentAcademic
    };
    const headers = new HttpHeaders();
    headers.append('Content-Type', 'application/json');
    headers.append('authToken', AUTHTOKEN);
    return this.http.post(this.URL + '/manageFees/discount/apply',
      params, { headers: this.headers }).pipe(map(res => res));
  }

  deleteDiscount(discountId, AUTHTOKEN, currentAcademic) {
    const params = { discountId, current_academic: currentAcademic };
    const headers = new HttpHeaders();
    headers.append('Content-Type', 'application/json');
    headers.append('authToken', AUTHTOKEN);
    return this.http.post(this.URL + '/manageFees/discount/delete',
      params, { headers: this.headers }).pipe(map(res => res));
  }

  fetchAppliedDiscountStudent(discountId, AUTHTOKEN, currentAcademic) {
    const params = { discountId, current_academic: currentAcademic };
    const headers = new HttpHeaders();
    headers.append('Content-Type', 'application/json');
    headers.append('authToken', AUTHTOKEN);
    return this.http.post(this.URL + '/manageFees/getAppliedDiscountStudentList',
      params, { headers: this.headers }).pipe(map(res => res));
  }

  fetchAppliedDiscountForStudent(discountId, studentId, AUTHTOKEN, currentAcademic) {
    const params = { discountId, studentId, current_academic: currentAcademic };
    const headers = new HttpHeaders();
    headers.append('Content-Type', 'application/json');
    headers.append('authToken', AUTHTOKEN);
    return this.http.post(this.URL + '/manageFees/getAppliedDiscountForStudent',
      params, { headers: this.headers }).pipe(map(res => res));
  }

  /* Fees settings related */

  getFeeModuleSettings(academicId) {
    const params = {};
    return this.http.post(this.URL + '/feesSettings/getFeesModuleSettings?academicId=' + academicId,
      params, { headers: this.headers }).pipe(map(res => res));
  }

  updateFeeModuleSettings(feesModuleSetting, settingName,academicId) {
    const params = { feesModuleSetting, settingName ,academicId};
    return this.http.post(this.URL + '/feesSettings/disableFeesModuleSetting',
      params, { headers: this.headers }).pipe(map(res => res));
  }

  getClassListWithOnlinePaymentSettings(academicId) {
    const params = {};
    return this.http.post(this.URL + '/feesSettings/classListWithOnlinePaymentSettings?academicId=' + academicId,
      params, { headers: this.headers }).pipe(map(res => res));
  }

  addOrRemoveClassOnlinePaySettings(settings) {
    const params = { settings };
    return this.http.post(this.URL + '/feesSettings/addOrRemoveClassOnlinePaySettings',
      params, { headers: this.headers }).pipe(map(res => res));
  }

  getOnlinePaymentPurposes() {
    const params = {};
    return this.http.post(this.URL + '/feesSettings/getOnlinePaymentPurposes',
      params, { headers: this.headers }).pipe(map(res => res));
  }

  addOnlinePaymentPurpose(purpose) {
    const params = { purpose };
    return this.http.post(this.URL + '/feesSettings/addOnlinePaymentPurpose',
      params, { headers: this.headers }).pipe(map(res => res));
  }

  deleteOnlinePaymentPurpose(purposeId) {
    const params = { purposeId };
    return this.http.post(this.URL + '/feesSettings/deleteOnlinePaymentPurpose',
      params, { headers: this.headers }).pipe(map(res => res));
  }

  getSchoolOnlineFeePaymentLimits() {
    const params = {};
    return this.http.post(this.URL + '/feesSettings/getSchoolOnlineFeePaymentLimits',
      params, { headers: this.headers }).pipe(map(res => res));
  }

  updateSchoolOnlineFeePaymentLimits(minimum, maximum) {
    const params = { minimum, maximum };
    return this.http.post(this.URL + '/feesSettings/updateSchoolOnlineFeePaymentLimits',
      params, { headers: this.headers }).pipe(map(res => res));
  }

  getInstamojoUserAccount() {
    const params = {};
    return this.http.post(this.URL + '/feesSettings/getInstamojoUserAccount',
      params, { headers: this.headers }).pipe(map(res => res));
  }

  createInstamojoAccount(username, email, phone, password) {
    const params = { username, email, phone, password };
    return this.http.post(this.URL + '/feesSettings/createInstamojoAccount',
      params, { headers: this.headers }).pipe(map(res => res));
  }

  loginInstamojoAccount(username, password) {
    const params = { userName: username, userPassword: password };
    return this.http.post(this.URL + '/feesSettings/login/instamojo', params, { headers: this.headers }).pipe(
      map(res => res)
    );
  }

  addInstamojoBankAccount(bankHolderName, accountNumber, iFSCCode, userId) {
    const params = {
      bankHolderName,
      accountNumber,
      iFSCCode,
      userId
    };
    return this.http.post(this.URL + '/feesSettings/insertBankInformation',
      params, { headers: this.headers }).pipe(
        map(res => res));
  }

  /* Student categories related */
  createStudentCategory(name, description, currentAcademic) {
    const params = { name, description, current_academic: currentAcademic };
    return this.http.post(this.URL + '/studentCategories/create',
      params, { headers: this.headers }).pipe(map(res => res));
  }

  editStudentCategory(name, description, id, currentAcademic) {
    const params = {
      name,
      description,
      studentCategoryId: id,
      current_academic: currentAcademic
    };
    return this.http.post(this.URL + '/studentCategories/edit',
      params, { headers: this.headers }).pipe(map(res => res));
  }

  getStudentCategoryList(forList, currentAcademic) {
    const params = { forList, current_academic: currentAcademic };
    return this.http.post(this.URL + '/studentCategories/list',
      params, { headers: this.headers }).pipe(map(res => res));
  }

  deleteStudentCategory(id, currentAcademic) {
    const params = { studentCategoryId: id, current_academic: currentAcademic };
    return this.http.post(this.URL + '/studentCategories/delete',
      params, { headers: this.headers }).pipe(map(res => res));
  }

  getClassListOfSchool() {
    const params = {};
    return this.http.post(this.URL + '/studentCategories/classes',
      params, { headers: this.headers }).pipe(map(res => res));
  }

  searchStudentToAssignCategory(classId, searchContent, currentAcademic) {
    const params = { classId, searchContent, current_academic: currentAcademic };
    return this.http.post(this.URL + '/studentCategories/search/student',
      params, { headers: this.headers }).pipe(map(res => res));
  }

  addStudentsToStudentCategory(students, studentCategoryId, currentAcademic) {
    const params = {
      students,
      studentCategoryId,
      current_academic: currentAcademic
    };
    return this.http.post(this.URL + '/studentCategories/addToCategory',
      params, { headers: this.headers }).pipe(map(res => res));
  }

  // Students already assigned to a category — same server-side paged endpoint the old
  // screen's DataTable called directly (countFrom / lengthOf / search / sort).
  getStudentsInCategory(body) {
    return this.http.post(this.URL + '/studentCategories/studentsInCategory',
      body, { headers: this.headers }).pipe(map(res => res));
  }

  moveStudentToAnotherStudentCategory(studentId, studentCategoryId, studentCategoryMemberId, oldCategoryId, currentAcademic) {
    const params = {
      studentId,
      studentCategoryId,
      studentCategoryMemberId,
      oldCategoryId,
      current_academic: currentAcademic
    };
    return this.http.post(this.URL + '/studentCategories/moveStudentCategory',
      params, { headers: this.headers }).pipe(map(res => res));
  }

  createFeeStructure(name, studentCategoryId, description, currentAcademic) {
    const params = {
      name,
      studentCategoryId,
      description,
      current_academic: currentAcademic
    };
    return this.http.post(this.URL + '/feeBoard/create',
      params, { headers: this.headers }).pipe(map(res => res));
  }

  updateFeeStructure(criteria, currentAcademic) {
    criteria.current_academic = currentAcademic;
    const params = criteria;
    return this.http.post(this.URL + '/feeBoard/updateFeeStructure',
      params, { headers: this.headers }).pipe(map(res => res));
  }

  deleteFeeStructure(structureId, currentAcademic) {
    const params = { structureId, current_academic: currentAcademic };
    return this.http.post(this.URL + '/feeBoard/deleteFeeStructure',
      params, { headers: this.headers }).pipe(map(res => res));
  }

  fetchFeeStructure(currentAcademic) {
    const params = { current_academic: currentAcademic };
    return this.http.post(this.URL + '/feeBoard/getFeeStructureList',
      params, { headers: this.headers }).pipe(map(res => res));
  }

  deleteCollectedFee(feesCollectionId, studentId, reasonId, reason, password, currentAcademic) {
    const params = {
      feesCollectionId,
      studentId,
      reasonId,
      reason,
      password,
      current_academic: currentAcademic
    };
    return this.http.post(this.URL + '/feeCollection/feeCollection/delete_v2',
      params, { headers: this.headers }).pipe(map(res => res));
  }

  getDeleteFeeCollectionReasons() {
    const params = {};
    return this.http.post(this.URL + '/feeCollection/update/reasons',
      params, { headers: this.headers }).pipe(map(res => res));
  }

  getStudentUpdateFeeHistory(studentId, classId, feeHistoryPageNumber, currentAcademic) {
    const params = {
      studentId,
      classId,
      page: feeHistoryPageNumber,
      current_academic: currentAcademic
    };
    return this.http.post(this.URL + '/feeCollection/studentFeeHistory/updates',
      params, { headers: this.headers }).pipe(map(res => res));
  }

  getAdminCancelledFeeHistory(adminId, stDate, edDate, currentAcademic) {
    const params = {
      startDate: stDate,
      endDate: edDate,
      adminId,
      current_academic: currentAcademic
    };
    return this.http.post(this.URL + '/feeCollection/studentFeeHistory/updates/admin',
      params, { headers: this.headers }).pipe(map(res => res));
  }

  getAllStudentFeeDetails(classId, AUTHTOKEN, currentAcademic) {
    const params = { classId, current_academic: currentAcademic };
    const headers = new HttpHeaders();
    headers.append('Content-Type', 'application/json');
    headers.append('authToken', AUTHTOKEN);
    return this.http.post(this.URL + '/manageFees/getAllStudentFeeDetails/v2',
      params, { headers: this.headers }).pipe(map(res => res));
  }

  getTypeTermBusTerms(AUTHTOKEN, currentAcademic) {
    const params = { current_academic: currentAcademic };
    const headers = new HttpHeaders();
    headers.append('Content-Type', 'application/json');
    headers.append('authToken', AUTHTOKEN);
    return this.http.post(this.URL + '/manageFees/getTermTypeBusTerms',
      params, { headers: this.headers }).pipe(map(res => res));
  }

  // getFeeStructureList_select

  getFeeStructureList_select(AUTHTOKEN, currentAcademic) {
    const params = { current_academic: currentAcademic };
    const headers = new HttpHeaders();
    headers.append('Content-Type', 'application/json');
    headers.append('authToken', AUTHTOKEN);
    return this.http.post(this.URL + '/feeBoard/getFeeStructureList_select',
      params, { headers: this.headers }).pipe(map(res => res));
  }

  getSectionsListFromStudentsCategory(feeStructureId, currentAcademic) {
    const params = { feeStructureId, current_academic: currentAcademic };
    return this.http.post(this.URL + '/studentCategories/getSectionsListFromStudentsCategory',
      params, { headers: this.headers }).pipe(map(res => res));
  }

  createFeeConfigurationGroup(groupName, currentAcademic) {
    const params = { groupName, current_academic: currentAcademic };
    return this.http.post(this.URL + '/manageFees/configuration/group/create',
      params, { headers: this.headers }).pipe(map(res => res));
  }

  getFinancialTermsOverviewFee(currentAcademic) {
    const params = { current_academic: currentAcademic };
    return this.http.post(this.URL + '/manageFees/academic/financialterm/overviewfee',
      params, { headers: this.headers }).pipe(map(res => res));
  }

  createOtherFee(name, amount, academicId) {
    const params = { name, amount, academicId };
    return this.http.post(this.URL + '/otherfee/add',
      params, { headers: this.headers }).pipe(map(res => res));
  }

  getOtherFee(academicId) {
    return this.http.get(this.URL + `/otherfee?academicId=${academicId}`,
      { headers: this.headers }).pipe(map(res => res));
  }

  editOtherFee(name, amount, pkOtherFeesId, academicId) {
    const params = { name, amount, pkOtherFeesId, academicId };
    return this.http.post(this.URL + '/otherfee/edit',
      params, { headers: this.headers }).pipe(map(res => res));
  }

  deleteOtherFee(pkOtherFeesId) {
    const params = { pkOtherFeesId };
    return this.http.post(this.URL + '/otherfee/delete',
      params, { headers: this.headers }).pipe(map(res => res));
  }

  searchStudentToAssignOtherFee(classId, searchContent, otherFeesId, currentAcademic) {
    const params = {
      classId,
      searchContent,
      otherFeesId,
      current_academic: currentAcademic
    };
    return this.http.post(this.URL + '/otherfee/search/student',
      params, { headers: this.headers }).pipe(map(res => res));
  }

  addStudentsToOtherFee(students, otherFeesId) {
    const params = { students, otherFeesId };
    return this.http.post(this.URL + '/otherfee/addToOtherFee',
      params, { headers: this.headers }).pipe(map(res => res));
  }

  getStudentsInOtherFee(otherFeesId) {
    const params = { otherFeesId };
    return this.http.post(this.URL + '/otherfee/studentsInOtherFee',
      params, { headers: this.headers }).pipe(map(res => res));
  }

  manageOtherFeeTerms(termsList, pkOtherFeesId) {
    const params = { termsList, pkOtherFeesId };
    return this.http.post(this.URL + '/otherfee/terms/manage',
      params, { headers: this.headers }).pipe(map(res => res));
  }

  getOtherFeeTerms(pkOtherFeesId) {
    const params = { pkOtherFeesId };
    return this.http.post(this.URL + '/otherfee/terms/list',
      params, { headers: this.headers }).pipe(map(res => res));
  }

  getStudentCategoriesFeeStructureStudentListDiscount(body) {
    return this.http.post(this.URL_V3 + this.studentCategoriesGetFeeStructureStudentListDiscount,
      body, { headers: this.headers }).pipe(map(res => res));
  }

  getStudentListDiscount(body) {
    return this.http.post(this.URL_V3 + '/get/student/list/discount',
      body, { headers: this.headers }).pipe(map(res => res));
  }

  getClassList(selectedClassId) {
    return this.http.get(this.URL_V3 + `${apiConstants.getClassListForFee}?lang=en&selectedClassId=${selectedClassId}`, { headers: this.headers }).pipe(map(res => res));

}

updateIsLateFeeIncludedInCurrentMonth(body: any) {
  return this.http.post(this.URL + '/update/school/settings/late/fee', body, {
    headers: this.headers
  }).pipe(map(res => res));
}

getAllFeesComponent(payload) {
  return this.http.get(this.URL_V3+`/fees/get/all/fees/component/list?academicId=${payload.academicId}&lang=${payload.lang}`, {
   headers: this.commonFunction.appendHeader()
  }).pipe(map(res => res));
}

addLateFeesData(body){
    return this.http.post(this.URL_V3+'/fees/add/late/fee',body, {
   headers: this.commonFunction.appendHeader()
  }).pipe(map(res => res));
}

updtaeLateFeesData(body){
    return this.http.put(this.URL_V3+'/fees/edit/late/fee',body, {
   headers: this.commonFunction.appendHeader()
  }).pipe(map(res => res));
}

getLateFeesComponent(payload){
    return this.http.get(this.URL_V3+`/fees/get/particular/late/fee/components?lang=${payload.lang}&academicId=${payload.academicId}&lateFeeId=${payload.lateFeeId}`, {
   headers: this.commonFunction.appendHeader()
  }).pipe(map(res => res));
}

// School-wide fees overview, broken down by student status — body.total/
// active/deactive each carry the same 5 metrics (expected collection,
// collected, discount, pending, late fees). Replaces the old two-call
// combo (fetchFeeDashDetails + getPaidLateFeeCount) for the v2 Overview
// tab's stat cards, which only ever covered "total" and needed a second
// request just for late fees.
getSchoolWiseFeesOverview(payload: { academicId: number | string; lang?: string }) {
  return this.http.get(this.URL_V3 + `/feesOverview/get/school/wise/fees/overview?academicId=${payload.academicId}&lang=${payload.lang || 'en'}`, {
    headers: this.commonFunction.appendHeader()
  }).pipe(map(res => res));
}

getClassStandardList(lang?: string) {
  return this.http.get(this.URL_V3 + `/feesOverview/get/class/standard/list?lang=${lang || 'en'}`, {
    headers: this.commonFunction.appendHeader()
  }).pipe(map(res => res));
}

getClassWiseFeesOverview(payload: { academicId: number | string; pageNumber: number; pageLimit: number; classStandardId: string | number; lang?: string }) {
  return this.http.get(this.URL_V3 + `/feesOverview/get/class/wise/fees/overview?academicId=${payload.academicId}&lang=${payload.lang || 'en'}&pageNumber=${payload.pageNumber}&pageLimit=${payload.pageLimit}&classStandardId=${payload.classStandardId}`, {
    headers: this.commonFunction.appendHeader()
  }).pipe(map(res => res));
}

exportClassWiseFeesOverview(payload: { academicId: number | string; classStandardId: string | number; studentStatus: string; lang?: string }) {
  return this.http.get(this.URL_V3 + `/feesOverview/export/class/wise/fees/overview?academicId=${payload.academicId}&lang=${payload.lang || 'en'}&classStandardId=${payload.classStandardId}&studentStatus=${payload.studentStatus}`, {
    headers: this.commonFunction.appendHeader(),
    responseType: 'blob' as 'json'
  }).pipe(map(res => res));
}
}